PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class ChangeSetPasswordPopoverView extends View
  initialize: ->
    @listenTo @model, 'change:loginTypes', @frameDebounce @render

  viewTitleKey: ->
    if 'password' !in @model.get('loginTypes')
      'set password'
    else
      'change password'

  events:
    'click .js-save-changes': 'saveChanges'

  render: ->
    view = @
    data = @model.toJSON(prefs: true, hasPassword: true)

    @$el.html(
      templates.fill('popover_change_set_password', data)
    )

    @

  getValue: (name) -> @$("[name=#{name}]").val()
  showPasswordError: (key) ->
    @$('#password-error').text(l(['password error', key])).show()

  saveChanges: (e) ->
    Util.preventDefault(e)

    @$('#password-error').hide()

    oldPassword = @getValue("oldpassword")
    newPassword = @getValue("password")
    newPassword2 = @getValue("password2")

    if newPassword || newPassword2
      if newPassword != newPassword2
        @showPasswordError('must match')
      else
        @model.run 'updatePassword', { oldPassword, newPassword }, (err) =>
          if !err?
            track("Member", "Changed Password")
            PopOver.popView()
            return
          @showPasswordError switch err.message.trim()
            when 'invalid value for newPassword' then 'not long enough'
            when 'The old password was incorrect' then 'old password'
            else 'unknown'
          return
      return
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/change-set-password-popover-view.coffee